module.exports = __webpack_public_path__ + "img/box-Creative-demo.b9c0eb86.png";